


























import { Component, Vue } from "vue-property-decorator";
@Component({
  name: "birthday-modal-component",
})
export default class BirthdayModalComponent extends Vue {
  get active() {
    return this.$store.getters["SystemStore/getShowBirthdayModal"];
  }
  set active(e) {
    this.$store.dispatch("SystemStore/setShowBirthdayModalAction", e);
  }
  get userBirthday() {
    return this.$store.getters["SystemStore/getDataBirthdayModal"];
  }
  congratulate() {
    if (!this.userBirthday) return;
    const messages = [
      this.$i18n.t("birthdayModal.birthdayMessage1"),
      this.$i18n.t("birthdayModal.birthdayMessage2"),
      this.$i18n.t("birthdayModal.birthdayMessage3"),
      this.$i18n.t("birthdayModal.birthdayMessage4"),
      this.$i18n.t("birthdayModal.birthdayMessage5"),
    ];
    const data = {
      message: messages[Math.floor(Math.random() * messages.length)],
      type: "CONGRATULATE_BIRTHDAY",
      color: "BLUE",
      sound: "NO_SOUND",
      hasConfirmation: false,
      spaceUsers: [{ id: this.userBirthday.spaceUserId }],
    };
    const localUser = this.$store.getters["UserStore/getSpaceUser"];
    this.$store.dispatch("SpaceStore/sendConsoleMessageAction", {
      spaceId: this.$store.getters["SpaceStore/getSpace"].id,
      data,
      callback: (response) => {
        this.$store.dispatch("GraphicClientStore/sendBirthdayCokeAction", {
          sendId: localUser.superSpaceUser.user.id,
          receiveId: this.userBirthday.id,
        });
      },
    });
    this.active = false;
  }
}
